import {useEffect} from 'react';
import { QuestsModel } from '../../Models/Quests/Quests.Model';
import {useMatch } from 'react-router-dom';
import MatrixView from './MatrixView/MatrixView'
import { PageLoadingView } from '../../App/Layout/Loading/LoadingView';

import { EditorCanvas } from './Quest/Canvas/EditorCanvas';
import { useSwivlNavigate } from '../../Models/NavBar/useSwivlNavigate';
import { InheritanceStatus, QuestType, MatrixQuestInterface } from '@swivl-mono/types';



export default function EditorWrapper () {
  // 
  const { quests, workflows } = QuestsModel.useState((s)=> s) 
  // const { bot }            = BotModel.useState((s)=> s)
  // const { user }          = UserModel.useState((s)=> s)

  const navigate = useSwivlNavigate()

  const match = useMatch("/quest/:slug")
  

  useEffect(()=>{
    if (match && match.params && match.params.slug) {

      QuestsModel.loadQuestsList(false).then(()=>{
        if (match && match.params && match.params.slug) {
          
          QuestsModel.loadQuest(match.params.slug, true)
        }
      })
    }
    }, [match]) 

 
    
  // const quest = QuestsModel.useQuest(match.params.id)


  if (!quests) { return <PageLoadingView navBarTitle=" " pageTitle=" " /> }
  const quest = match && quests ? quests[match.params.slug!] :  undefined
  

  if (match && quests && !quest) return <div>Quest not found</div>
  if (quest && !quest.data) { return <PageLoadingView navBarTitle=" " pageTitle=" " /> }

  const canEdit = quest?.inheritance !== InheritanceStatus.IS_PARENT;
  
  if (quest?.type === QuestType.MATRIX) {
    return <MatrixView matrix={quest as MatrixQuestInterface } workflows={workflows} canEdit={canEdit} />
  }

  return <EditorCanvas key={quest!.slug} navigate={navigate} quest={quest!} canEdit={canEdit} />
}


